<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="graphics-symbol">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.7 9.5C3.7 7.69653 4.41643 5.96692 5.69167 4.69167C6.96692 3.41643 8.69653 2.7 10.5 2.7C12.3035 2.7 14.0331 3.41643 15.3083 4.69167C16.5836 5.96692 17.3 7.69653 17.3 9.5C17.3 11.3035 16.5836 13.0331 15.3083 14.3083C14.0331 15.5836 12.3035 16.3 10.5 16.3C8.69653 16.3 6.96692 15.5836 5.69167 14.3083C4.41643 13.0331 3.7 11.3035 3.7 9.5ZM10.5 1C5.80545 1 2 4.80545 2 9.5C2 14.1946 5.80545 18 10.5 18C15.1946 18 19 14.1946 19 9.5C19 4.80545 15.1946 1 10.5 1ZM11.35 4.4C11.35 4.17457 11.2604 3.95837 11.101 3.79896C10.9416 3.63955 10.7254 3.55 10.5 3.55C10.2746 3.55 10.0584 3.63955 9.89896 3.79896C9.73955 3.95837 9.65 4.17457 9.65 4.4V9.5C9.65005 9.72542 9.73963 9.94158 9.89905 10.101L12.4491 12.651C12.6094 12.8058 12.8241 12.8915 13.0469 12.8895C13.2698 12.8876 13.483 12.7982 13.6406 12.6406C13.7982 12.483 13.8876 12.2698 13.8895 12.0469C13.8915 11.8241 13.8058 11.6094 13.651 11.4491L11.35 9.1481V4.4Z"
    />
  </svg>
</template>
